import React, { useEffect, useState } from "react";
import MainLayout from "../../components/layout";
import { role, token_leads, token_user } from "../../../../helpers/auth";
import { PremiumLayoutSkeleton } from "../../../../components/page-skeleton";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card } from "antd";
import http from "../../../../services/http";
import { LANDING_PAGE_URL } from "../../../../constant";
import Cookie from "js-cookie";
import { toast } from "react-toastify";

const SignupCancel = () => {
  const history = useHistory();
  const { subscription } = useParams();
  const [isAuthenicated, setAuthenicated] = useState(true);

  useEffect(() => {
    const expirationTimestamp = localStorage.getItem("expirationTimestamp");
    if (expirationTimestamp && Date.now() > parseInt(expirationTimestamp, 10)) {
      Object.keys(Cookie.get()).forEach((cookieName) => {
        Cookie.remove(cookieName);
      });
      setAuthenicated(false);
    } else if (role === "leads" && token_leads) {
      history.replace("/leads");
    } else if (role === "user" && token_user) {
      history.replace("/home");
    } else {
      setAuthenicated(false);
    }
    localStorage.removeItem("expirationTimestamp");
  }, []);

  const retryHandler = () => {
    if (!subscription) return;
    http
      .post(`/retry-register-payment/${subscription}`)
      .then(({ data }) => {
        window.location.href = data.checkout;
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  if (isAuthenicated)
    return (
      <div className="loading-screen">
        <PremiumLayoutSkeleton />
      </div>
    );

  return (
    <MainLayout>
      <Card className="signup-action-wrapper">
        <h1>Payment Canceled</h1>
        <p>
          Your payment process was canceled. If this was unintentional, please retry the
          payment process.
        </p>
        <div className="action-wrapper">
          <Button
            type="primary"
            onClick={() => window.location.replace(LANDING_PAGE_URL)}
            className="action-btn"
          >
            Back to home
          </Button>
          <Button type="primary" onClick={retryHandler} className="action-btn">
            Retry
          </Button>
        </div>
      </Card>
    </MainLayout>
  );
};

export default SignupCancel;
